import React from 'react';
import {
  FaUsers, FaGlobeAmericas, FaPassport,
  FaGraduationCap
} from 'react-icons/fa';
import ContactCTA from '../components/ContactCTA';
import '../styles/Services.css';

const services = [
  {
    icon: <FaGlobeAmericas />,
    title: 'Global Placements',
    description: 'We specialize in connecting world-class talent with international opportunities across diverse sectors and geographies. Our global network ensures you secure the ideal candidate, regardless of borders, driving excellence in your worldwide operations.',
    image: '/images/global-placements.png',
    imageAlt: 'Happy professionals achieving global career success'
  },
  {
    icon: <FaPassport />,
    title: 'Immigration Services',
    description: 'We manage the complex logistics of cross-border employment, facilitating necessary visas, work permits, and relocation support. Our expertise ensures smooth, compliant transitions for your talent, minimizing delays and mitigating legal risks.',
    image: '/images/imm-services.jpg',
    imageAlt: 'Travel and immigration - airplane journey to new opportunities'
  },
  {
    icon: <FaUsers />,
    title: 'Human Resources and Management Efficiency Services',
    description: 'We provide strategic HR consulting and executive advisory to optimize your workforce, enhance business efficiency, and ensure compliance across all jurisdictions. Our solutions cover organizational design, leadership development, performance management, and translate HR strategy into measurable business outcomes.',
    image: '/images/hr-services.jpg',
    imageAlt: 'HR team collaboration in modern office'
  },
  {
    icon: <FaGraduationCap />,
    title: 'Student Services',
    description: 'We guide aspiring students through the intricate process of international education placement, career planning, and vocational counseling. Our services ensure students choose the best institutions globally and are well-prepared to enter the professional workforce afterward.',
    image: '/images/student-services.jpg',
    imageAlt: 'Graduate student celebrating academic achievement'
  }
];

const Services = () => {
  return (
    <div className="services-page">
      <section className="page-hero">
        <div className="container">
          <h1>Our Services</h1>
          <p>Supporting businesses, professionals, and students navigate the complexities of global expansion, staffing, and education</p>
        </div>
      </section>

      <section className="services-intro">
        <div className="container">
          <p className="intro-text">
            At JOY WORLDWIDE CONSULTANCY SERVICES (JWCS), we offer a cohesive suite of services designed to support businesses, professionals, and students navigate the complexities of global expansion, staffing, and education.
          </p>
        </div>
      </section>

      <section className="services-category">
        <div className="container">
          <div className="services-grid">
            {services.map((service, index) => (
              <div className="service-card" key={index}>
                <div className="service-card-image">
                  <img src={service.image} alt={service.imageAlt} />
                </div>
                <div className="service-card-content">
                  <div className="service-icon">{service.icon}</div>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* <section className="industries-showcase">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Industries We Serve</h2>
            <p className="section-description">
              From healthcare to industrial sectors, we connect exceptional talent with leading organizations
            </p>
          </div>
          <div className="industries-grid">
            <div className="industry-card">
              <img src="/images/04841de1-4dca-4b6e-bd11-eaf72b27d4c9.jpg" alt="Healthcare Staffing - Medical Team" />
              <div className="industry-overlay">
                <h3>Healthcare Staffing</h3>
                <p>Nurses, physicians, and medical professionals</p>
              </div>
            </div>
            <div className="industry-card">
              <img src="/images/3243aa9c-3259-4ce9-ace5-d91c9a2b9f36.jpg" alt="Industrial Staffing - Engineers" />
              <div className="industry-overlay">
                <h3>Industrial & Engineering</h3>
                <p>Skilled technicians and engineers</p>
              </div>
            </div>
            <div className="industry-card">
              <img src="/images/60120614-fac4-4720-9a8e-d5050d99634f.jpg" alt="Medical Professionals" />
              <div className="industry-overlay">
                <h3>Medical Professionals</h3>
                <p>Specialized healthcare talent</p>
              </div>
            </div>
            <div className="industry-card">
              <img src="/images/f8fbfbe6-e524-4b7c-97d4-8803c0bca3c7.jpg" alt="Manufacturing Workforce" />
              <div className="industry-overlay">
                <h3>Manufacturing</h3>
                <p>Skilled manufacturing workforce</p>
              </div>
            </div>
          </div>
        </div>
      </section> */}

<ContactCTA />
    </div>
  );
};

export default Services;
